var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerHub',{staticClass:"hub-profile"},[_c('template',{slot:"header"},[_c('HubHeader',{attrs:{"titleTag":'h1',"title":_vm.title,"description":_vm.description,"email":_vm.email}})],1),_c('template',{slot:"body"},[_c('TheProfile')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }